import authInterceptor from "../AuthInterceptor";

export const UploadDataAPI = {
    uploadFile: (bodyData) =>
        authInterceptor.post(`ranking-api/raw-file-upload/`, bodyData, { headers: { "Content-Type": "multipart/form-data", } })
            .then((response) => response.data)
            .catch((error) => error.response?.data),
    reRank: (config) =>
        authInterceptor.get(`ranking-api/re-rank-data/`, config)
            .then((response) => response.data)
            .catch((error) => error.response),
             downloadTemplate: () =>
    authInterceptor
      .get(`ranking-api/download-template/`, {
        responseType: "blob",
      })
      .then((response) => response)
      .catch((error) => error.response),
}